import React from 'react';
import Username from '../common/Username';

const RosterMember = (props) => (
    <div className="clearfix col-md-4 panel-roster-member">
        <div className="pull-left">
            <img
                className="roster-member-rank"
                alt="rank"
                src={props.ranks[props.member.rank].image}
                width={props.role ? "38px" : "22px"}
                height={props.role ? "38px" : "22px"}
            />
        </div>
        <Username user={props.member} rank={props.ranks[props.member.rank]} />
        <div>{props.role}</div>
    </div>
);

export default RosterMember;


// WEBPACK FOOTER //
// ./src/Roster/RosterMember.js